var map = {
	"./de/countries.json": 59922,
	"./de/email.json": 63855,
	"./de/shopify.json": 71577,
	"./de/translation.json": 51804,
	"./en-GB/countries.json": 38057,
	"./en-GB/translation.json": 16504,
	"./en/countries.json": 6273,
	"./en/email.json": 13243,
	"./en/shopify.json": 8461,
	"./en/translation.json": 71984,
	"./es-MX/countries.json": 52272,
	"./es-MX/email.json": 63082,
	"./es-MX/shopify.json": 14204,
	"./es-MX/translation.json": 31793,
	"./es/countries.json": 42490,
	"./es/shopify.json": 21294,
	"./fr/countries.json": 26754,
	"./fr/email.json": 42200,
	"./fr/shopify.json": 69606,
	"./fr/translation.json": 96075,
	"./it/countries.json": 12455,
	"./it/email.json": 13357,
	"./it/shopify.json": 37723,
	"./it/translation.json": 83062,
	"./nl/countries.json": 29968,
	"./nl/shopify.json": 14012
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64689;